import HowDeliverooWorksContainer from '../../../../containers/HowDeliverooWorksContainer';

export default HowDeliverooWorksContainer;
